import SpriteSymbol from "../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "icon-result-monitoring",
  "use": "icon-result-monitoring-usage",
  "viewBox": "0 0 24 24",
  "content": "<symbol fill=\"currentColor\" xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 24 24\" id=\"icon-result-monitoring\"><path d=\"M3 1.5H1.5V21A1.5 1.5 0 0 0 3 22.5h19.5V21H3V1.5Z\" /><path d=\"M22.5 6.75h-5.25v1.5h2.692l-5.692 5.693-3.217-3.226a.75.75 0 0 0-1.066 0L4.5 16.192l1.058 1.058 4.942-4.943 3.217 3.226a.75.75 0 0 0 1.066 0L21 9.306V12h1.5V6.75Z\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol